import { Button, Menu } from "@mui/material";
import { KeyboardEvent, useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import BasicSelect from "components/BasicInputs/BasicSelect";
import StartFrom from "../../assets/svg/tableFilter/StartFrom.svg";
import EndFrom from "../../assets/svg/tableFilter/EndFrom.svg";
import Includes from "../../assets/svg/tableFilter/Includes.svg";
import NotInclude from "../../assets/svg/tableFilter/NotInclude.svg";
import NotEqual from "../../assets/svg/tableFilter/NotEqual.svg";
import Equal from "../../assets/svg/tableFilter/Equal.svg";
import SmallerThan from "../../assets/svg/tableFilter/SmallerThan.svg";
import GreaterThan from "../../assets/svg/tableFilter/GreaterThan.svg";
import GreaterEqual from "../../assets/svg/tableFilter/GreaterEqual.svg";
import SmallerEqual from "../../assets/svg/tableFilter/SmallEqual.svg";
import Between from "../../assets/svg/tableFilter/Between.svg";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import HintInput from "components/Input/HintInput";
import { getOptions } from "components/Input/functions";
import { useDispatch, useSelector } from "react-redux";
import { formatPrice, S2N } from "helpers";
import CloseIcon from "assets/icons/CloseIcon";
import useKeyboardShortcuts from "../../helpers/useKeyboardShortcuts";

export interface TableSearchMenuProps {
  setSearchQuery: (items: any) => void;
  title: any;
  searchItems: (sort?: any, search?: any) => void;
  activeTab?: any;
  searchColumn?: string;
  onChangeSearchColumn?: (value: string) => void | undefined;
}

const optionsString = [
  { label: "شامل شود", value: "", id: 1, image: Includes },
  { label: "شامل نشود", value: "", id: 2, image: NotInclude },
  { label: "شروع شود با", value: "", id: 3, image: StartFrom },
  { label: "خاتمه یابد", value: "", id: 4, image: EndFrom },
  { label: "برابر باشد با", value: "", id: 5, image: Equal },
  { label: "برابر نباشد با", value: "", id: 6, image: NotEqual },
];
const optionsNumber = [
  { label: "برابر باشد", value: "", id: 1, image: Equal },
  { label: "برابر نباشد", value: "", id: 2, image: NotEqual },
  { label: "کوچک تر از", value: "", id: 3, image: SmallerThan },
  { label: "بزرگتر از", value: "", id: 4, image: GreaterThan },
  { label: "کوچکتر/ مساوی", value: "", id: 5, image: SmallerEqual },
  { label: "بزرگتر/ مساوی", value: "", id: 6, image: GreaterEqual },
  { label: "بین", value: "", id: 7, image: Between },
];

export default function TableSearchMenu(props: TableSearchMenuProps) {
  const dispatch = useDispatch();
  const { title, onChangeSearchColumn = () => null, searchColumn } = props;
  const columnType = props.title?.columnType
  const column = props.title.key
  const model = props.title.model || null
  const { searchType = "default" } = props?.title;
  const state = useSelector((state) => state);
  //@ts-ignore
  const pagination = useSelector((state) => state).paginationState;
  const [text, setText] = useState<string>("");
  const [label, setLabel] = useState<string>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // when filter search
  const [filter, setFilter] = useState<any>(
    searchType === "quantitative" ? optionsNumber[0] : optionsString[0]
  );
  const [startText, setStartText] = useState<string>("");
  const [endText, setEndText] = useState<string>("");
  const inputReference = useRef(null);
  // const { toDate, fromDate, setDates } = useDateState();

  // date state
  const [toDate, setToDate] = useState<any>(undefined);
  const [fromDate, setFromDate] = useState<any>(undefined);

  useEffect(() => {
    if (searchColumn !== title?.filterParams?.column) {
      reload(false);
    }
  }, [searchColumn]);

  // set date function
  function setDates(dates?: string[]) {
    if (dates) {
      setFromDate(dates[0]);
      setToDate(dates[1]);
    } else {
      setFromDate(undefined);
      setToDate(undefined);
    }
  }

  //===========

  // ====================

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  interface SearchQueryParam {
    [key: string]: any;
  }
  interface NewVersionFilter {
    column: string
    filterType: number | string
    columnType: string
    primarySearch: string
    secondarySearch: string
    model?: string
  }

  const submit = () => {
    if (typeof columnType === "string") {
      const filterParams: NewVersionFilter = {
        column,
        columnType,
        filterType: columnType === "date" ? "3" : filter.id.toString(),
        primarySearch: columnType === "date" ? S2N(fromDate) : startText || text,
        secondarySearch: columnType === "date" ? S2N(toDate) : endText,
        model

      }
      props.setSearchQuery(filterParams);

    } else {

      const filterParams = { ...title.filterParams, sortParams: undefined };

      let defaultSearchQuery: SearchQueryParam = {
        primarySearch: searchType === "quantitative" ? S2N(text) : text,
        // subColumn: title.mainColumn ? null : title.searchKey ?? title.key,
        // altSearchText: title.mainColumn ? null : text,
        filterType: searchType === "date" ? '7' : filter.id.toString(),
        ...filterParams,
      };

      if (filter.id == "7") {
        defaultSearchQuery.primarySearch = S2N(startText);
        defaultSearchQuery.secondarySearch = S2N(endText);
      }

      if (searchType === "date") {
        defaultSearchQuery.primarySearch = S2N(fromDate);
        defaultSearchQuery.secondarySearch = S2N(toDate);
        defaultSearchQuery.type = "7";
      }

      props.setSearchQuery(defaultSearchQuery);
    }
    // props.searchItems(undefined, defaultSearchQuery)
    if (searchType === "date" || columnType === "date") {
      setLabel(fromDate + "-" + toDate);
    } else if (columnType === "date" || (searchType === "quantitative" && filter.id != "7")) {
      //@ts-ignore
      setLabel(formatPrice(text));
    } else if (filter.id == "7") {
      //@ts-ignore
      setLabel(formatPrice(startText) + "-" + formatPrice(endText));
    } else if (searchType !== "status") {
      setLabel(text);
    }
    // onChangeSearchColumn(title?.filterParams?.column);
    // if (filter.id === "7" ) {

    // } else if (searchType === "quantitative") {
    //   //@ts-ignore
    //   setLabel(formatPrice(text));
    // } else {
    //   setLabel(text);
    // }

    setTimeout(() => {
      handleClose();
    }, 200);
  };

  const onChange = (value: string, options: any) => {
    setFilter(options);
  };

  const getColumOptions = () => {
    let newOptions: any = [];
    const options = getOptions(title?.dataKey?.column, state);
    options?.map((item: { [x: string]: any }) => newOptions.push(item[title?.dataKey?.key]));
    return newOptions;
  };

  const reload = (reloadData = true) => {
    if (typeof columnType === "string") {
      const filterParams: NewVersionFilter = {
        column,
        columnType,
        filterType: 1,
        primarySearch: "",
        secondarySearch: "",
        model

      }
      props.setSearchQuery(filterParams);
    } else {
      reloadData && props.setSearchQuery({
        column,
        columnType,
        filterType: 1,
        primarySearch: null,
        secondarySearch: null,
        model
      });

    }
    // props.searchItems(undefined, {});
    setLabel(undefined);
    {
      reloadData &&
        setTimeout(() => {
          handleClose();
        }, 200);
    }
    setText("");
    setStartText("");
    setEndText("");
    setFilter(searchType === "quantitative" ? optionsNumber[0] : optionsString[0]);
    reloadData && onChangeSearchColumn("");
  };

  useKeyboardShortcuts(
    [
      {
        key: "keyboardShortcutResetSearch",
        value: "alt+R",
        label: "باز نشانی جستجو",
      },
    ],
    () => {
      reload();
    }
  );

  if (title?.disableSearch) {
    return null;
  }
  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => {
          if (searchColumn === title?.filterParams?.column) {
            reload();
          } else {
            handleClick(e);
          }
        }}
        style={{
          backgroundColor: "transparent",
          padding: 0,
          color: "#AEAEAE",
          display: "flex",
          gap: "10px",
        }}
        className={`${searchColumn === title?.filterParams?.column &&
          "border border-blue-1 rounded w-full py-[2px] flex-row justify-between px-2 items-center"
          }`}
        size="small"
      >
        <span> {label || "فیلتر و جستجو"}</span>
        <span>
          {searchColumn !== title?.filterParams?.column ? (
            <SearchIcon fontSize="small" style={{ color: "#AEAEAE" }} />
          ) : (
            <CloseIcon scale={0.4} />
          )}
        </span>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
        style={{ borderRadius: 4 }}
        disableScrollLock={false}
      >
        {((searchType === "default" || searchType === "quantitative" || searchType === "autocomplete") || columnType === "string") ? (
          <div
            style={{
              padding: "10px 20px",
              minWidth: 350,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            {/* <p style={{width: "100%"}}>
                        <span>جستجو در "{title.name}"</span>
                    </p> */}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: "13px",
                flexDirection: "row",
              }}
            >
              <span>جستجو : </span>

              <div style={{ width: "150px" }}>
                <BasicSelect
                  options={searchType === "quantitative" || columnType === "number" ? optionsNumber : optionsString}
                  onChange={onChange}
                  placeholder={filter?.label || ""}
                />
              </div>
            </div>
            {filter.id == "7" ? (
              <div>
                <input
                  type="search"
                  placeholder="شروع"
                  value={formatPrice(startText)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      // submit();
                      //@ts-ignore
                      inputReference.current.focus();
                    }
                    e.stopPropagation();
                  }}
                  onChange={(e) => setStartText(e.target.value)}
                  style={{
                    outline: "none",
                    border: "0.5px solid #E1EAF5",
                    borderRadius: "4px",
                    color: "#AEAEAE",
                    padding: "5px 10px",
                    width: "100%",
                    fontSize: "14px",
                  }}
                />
                <input
                  ref={inputReference}
                  type="search"
                  placeholder="خاتمه"
                  value={formatPrice(endText)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      submit();
                    }
                    e.stopPropagation();
                  }}
                  onChange={(e) => setEndText(e.target.value)}
                  style={{
                    outline: "none",
                    border: "0.5px solid #E1EAF5",
                    borderRadius: "4px",
                    color: "#AEAEAE",
                    padding: "5px 10px",
                    width: "100%",
                    fontSize: "14px",
                    marginTop: "8px",
                  }}
                />
              </div>
            ) : (
              <>
                {searchType === "autocomplete" ? (
                  <HintInput
                    text={text}
                    onChange={(value) => setText(value)}
                    options={getColumOptions() || []}
                  />
                ) : searchType === "quantitative" || columnType === "number" ? (
                  <input
                    type="search"
                    placeholder="مقدار مورد نظر خود را جستجو کنید"
                    value={text}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        submit();
                      }
                      e.stopPropagation();
                    }}
                    onChange={(e) => setText(e.target.value)}
                    style={{
                      outline: "none",
                      border: "0.5px solid #E1EAF5",
                      borderRadius: "4px",
                      color: "#AEAEAE",
                      padding: "5px 10px",
                      width: "100%",
                      fontSize: "14px",
                    }}
                  />
                ) : (
                  <input
                    type="search"
                    placeholder="مقدار مورد نظر خود را جستجو کنید"
                    value={text}
                    // onKeyDown={(e) => {
                    //   if (e.key === "Enter") {
                    //     submit();
                    //   }
                    // }}
                    onKeyDown={(e: KeyboardEvent) => {
                      if (e.key === "Enter") {
                        submit();
                      }
                      e.stopPropagation();
                    }}
                    onChange={(e) => setText(e.target.value)}
                    style={{
                      outline: "none",
                      border: "0.5px solid #E1EAF5",
                      borderRadius: "4px",
                      color: "#AEAEAE",
                      padding: "5px 10px",
                      width: "100%",
                      fontSize: "14px",
                    }}
                  />
                )}
              </>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "24px",
                width: "100%",
                gap: "10px",
                flexDirection: "row-reverse",
              }}
            >
              <Button
                variant="contained"
                onClick={submit}
                style={{
                  padding: "5px 40px",
                }}
              >
                <span>اعمال</span>
              </Button>
              <Button
                variant="text"
                color="disabled"
                onClick={() => {
                  reload();
                }}
                style={{
                  padding: "5px 22px",
                }}
              >
                <span>باز نشانی</span>
              </Button>
            </div>
          </div>
        ) : (searchType === "date" || columnType === "date") ? (
          <div
            style={{
              padding: "10px 20px",
              minWidth: 350,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <div style={{ width: 300 }}>
              <BasicDateInput
                range
                placeholder="انتخاب بازه زمانی"
                onChange={(dates) => setDates(dates)}
                defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "24px",
                width: "100%",
                gap: "10px",
                flexDirection: "row-reverse",
              }}
            >
              <Button
                variant="contained"
                onClick={submit}
                style={{
                  padding: "5px 40px",
                }}
              >
                <span>اعمال</span>
              </Button>
              <Button
                variant="text"
                color="disabled"
                onClick={() => {
                  reload();
                }}
                style={{
                  padding: "5px 22px",
                }}
              >
                <span>باز نشانی</span>
              </Button>
            </div>
          </div>
        ) : (
          <div
            style={{
              padding: "10px 20px",
              minWidth: "300px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <div style={{ width: "250px" }}>
              <BasicSelect
                options={title?.dataKey}
                onChange={(val, option) => {
                  setLabel(option?.label);
                  setText(option?.value);
                  setStartText(option?.value);
                  setFilter({
                    label: "شامل شود",
                    value: option.value,
                    id: 1,
                    image: Includes,
                  });
                }}
                placeholder={"انتخاب فیلتر"}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "24px",
                width: "100%",
                gap: "10px",
                flexDirection: "row-reverse",
              }}
            >
              <Button
                variant="contained"
                onClick={submit}
                style={{
                  padding: "5px 40px",
                }}
              >
                <span>اعمال</span>
              </Button>
              <Button
                variant="text"
                color="disabled"
                onClick={() => {
                  // setAnchorEl(null);
                  reload();
                }}
                style={{
                  padding: "5px 22px",
                }}
              >
                <span>باز نشانی</span>
              </Button>
            </div>
          </div>
        )}
      </Menu>
    </>
  );
}
